import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      borderRadius: [
        "big-comp-sm",
        "comp-lg",
        "comp-md",
        "comp-sm",
        "big-comp-md",
        "figma-md",
        "xxl",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}

/**
 * Chuyển đổi một string từ snake_case sang camelCase
 */
export const toCamel = (s: string) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};

/**
 * Chuyển đổi các key của một object từ snake_case sang camelCase một cách đệ quy
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const snakeToCamel = (obj: unknown): any => {
  if (Array.isArray(obj)) {
    return obj.map((v) => snakeToCamel(v));
  } else if (
    obj !== null &&
    typeof obj === "object" &&
    obj.constructor === Object
  ) {
    return Object.keys(obj as Record<string, unknown>).reduce(
      (result, key) => ({
        ...result,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [toCamel(key)]: snakeToCamel((obj as Record<string, any>)[key]),
      }),
      {},
    );
  }
  return obj;
};
